import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { enumData } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.packageCategoryEnum = [];
    _this.formDataRule = {
      package_category: [{
        required: true,
        message: _this.t('请选择包材类型')
      }],
      package_code: [{
        required: true,
        message: _this.t('请输入包材编码')
      }],
      package_name: [{
        required: true,
        message: _this.t('请输入包材名称')
      }],
      warehouse_code_list: [{
        required: true,
        type: 'array',
        message: _this.t('请选择适用仓库（区域）')
      }],
      weight: [{
        required: true,
        message: _this.t('请输入重量')
      }, {
        pattern: /^([0](\.(?!0+$)[0-9]{1,3})|[1-9][0-9]{0,4}(\.[0-9]{1,3})?)$/,
        message: _this.t('重量限制0.001-99999.999之间')
      }],
      max_weight: [{
        required: true,
        message: _this.t('请输入最大重量')
      }, {
        pattern: /^([0](\.(?!0+$)[0-9]{1,3})|[1-9][0-9]{0,4}(\.[0-9]{1,3})?)$/,
        message: _this.t('最大重量限制0.001-99999.999之间')
      }],
      inner_box_length: [{
        required: true,
        message: _this.t('请输入长')
      }, {
        pattern: /^([0](\.(?!0+$)[0-9][0-9]?)|[1-9][0-9]{0,3}(\.[0-9]{1,2})?)$/,
        message: _this.t('长限制0.01-9999.99之间')
      }],
      inner_box_width: [{
        required: true,
        message: _this.t('请输入宽')
      }, {
        pattern: /^([0](\.(?!0+$)[0-9][0-9]?)|[1-9][0-9]{0,3}(\.[0-9]{1,2})?)$/,
        message: _this.t('宽限制0.01-9999.99之间')
      }],
      inner_box_height: [{
        required: true,
        message: _this.t('请输入高')
      }, {
        pattern: /^([0](\.(?!0+$)[0-9][0-9]?)|[1-9][0-9]{0,3}(\.[0-9]{1,2})?)$/,
        message: _this.t('高限制0.01-9999.99之间')
      }]
    };
    _this.formData = _this.initFormData();
    return _this;
  }

  AddEditModal.prototype.initFormData = function (data) {
    var originData = {
      id: undefined,
      package_category: undefined,
      package_code: '',
      package_name: '',
      warehouse_code_list: [],
      inner_box_height: undefined,
      inner_box_length: undefined,
      inner_box_width: undefined,
      weight: undefined,
      max_weight: undefined
    };

    if (data) {
      for (var key in originData) {
        if (data.hasOwnProperty(key)) {
          originData[key] = data[key];
        }
      }
    }

    return originData;
  };

  AddEditModal.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, validateRes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            validateRes = _a.sent();

            if (!validateRes) {
              return [2];
            }

            this.normalizePackageCodeToUpperCase();
            if (!this.formData.id) return [3, 3];
            return [4, this.$api.wrapper.editWrapper(this.formData)];

          case 2:
            _a.sent();

            return [3, 5];

          case 3:
            return [4, this.$api.wrapper.addWrapper(this.formData)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            this.handleClose();
            this.$emit('success');
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddEditModal.prototype.normalizePackageCodeToUpperCase = function () {
    var packageCode = this.formData.package_code;

    if (!packageCode) {
      return;
    }

    this.formData.package_code = packageCode.toUpperCase();
  };

  AddEditModal.prototype.handlePackageCodeBlur = function () {
    this.normalizePackageCodeToUpperCase();
  };

  AddEditModal.prototype.handleVisibleChange = function () {
    if (this.visible) {
      this.formData = this.initFormData(this.rowData.data);
    } else {
      var formDataRef = this.$refs.formDataRef;
      formDataRef && formDataRef.clearValidate();
    }
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddEditModal.prototype, "visible", void 0);

  __decorate([Prop({})], AddEditModal.prototype, "rowData", void 0);

  __decorate([enumData('Wrapper/PackageCategoryEnum')], AddEditModal.prototype, "packageCategoryEnum", void 0);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], AddEditModal.prototype, "handleVisibleChange", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;